import { render, staticRenderFns } from "./AvailabilityWeekCalendar.vue?vue&type=template&id=10a329f2&scoped=true"
import script from "./AvailabilityWeekCalendar.vue?vue&type=script&lang=js"
export * from "./AvailabilityWeekCalendar.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityWeekCalendar.vue?vue&type=style&index=0&id=10a329f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a329f2",
  null
  
)

export default component.exports